import styled from "styled-components";

export const Content = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border: none; //5px solid blue;
`;
